var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00288 13.1665L8.00021 7.16655M13.5062 10.9385C14.04 10.5632 14.4404 10.0274 14.6491 9.40909C14.8578 8.79075 14.864 8.122 14.6669 7.49988C14.2625 6.22321 13.0235 5.52355 11.6845 5.52488H10.9109C10.7263 4.80508 10.3807 4.13655 9.90034 3.56962C9.41994 3.00269 8.81719 2.55213 8.13745 2.25187C7.45772 1.95162 6.71873 1.80949 5.97611 1.83618C5.23349 1.86287 4.50661 2.0577 3.85019 2.40598C3.19376 2.75426 2.62491 3.24693 2.18646 3.84689C1.74801 4.44685 1.45138 5.13847 1.31891 5.86966C1.18645 6.60086 1.2216 7.35257 1.42171 8.06822C1.62182 8.78386 1.98169 9.44478 2.47421 10.0012",
    stroke: "black",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1216 8.71215L8.00024 6.59082L5.87891 8.71215",
    stroke: "black",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon1);
export default __webpack_public_path__ + "static/media/DownloadIcon1.13fb0c94187936d3fab61e44eb3c40fa.svg";
export { ForwardRef as ReactComponent };